import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71a8e66c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-grid" }
const _hoisted_2 = { class: "station" }
const _hoisted_3 = { class: "station_label" }
const _hoisted_4 = { class: "station_name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_6 = { class: "ta-e mr-3" }
const _hoisted_7 = ["data-tooltip"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spliter" }, null, -1))
const _hoisted_11 = { class: "ta-e timesheet merge-col-ends" }
const _hoisted_12 = { class: "station" }
const _hoisted_13 = { class: "station_label" }
const _hoisted_14 = { class: "station_name" }
const _hoisted_15 = { class: "ta-e number merge-col-ends" }
const _hoisted_16 = { style: {"font-weight":"600"} }
const _hoisted_17 = {
  key: 0,
  class: "ta-l"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = { href: "https://ressources.data.sncf.com/explore/dataset/tgvmax/information/" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.journey)
    ? (_openBlock(), _createElementBlock("article", {
        key: 0,
        class: _normalizeClass({ disable: !_ctx.journey.available })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("result.from")), 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.titleCaseGare(_ctx.journey.origin.label)), 1)
          ]),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.journey.available ? _ctx.$t("result.available") : _ctx.$t("result.notAvailable")) + " ", 1),
            (_ctx.journey.available)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.moreInfo = !_ctx.moreInfo)),
                  class: "ml-1",
                  "data-tooltip": 
            _ctx.moreInfo
              ? _ctx.$t('result.tooltip.close')
              : _ctx.$t('result.tooltip.moreInfo')
          
                }, [
                  (!_ctx.moreInfo)
                    ? (_openBlock(), _createElementBlock("sup", _hoisted_8, "ⓘ"))
                    : _createCommentVNode("", true),
                  (_ctx.moreInfo)
                    ? (_openBlock(), _createElementBlock("sup", _hoisted_9, "☒"))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.humanizeDatetime(_ctx.journey.departureDate)) + " ➔ " + _toDisplayString(_ctx.humanizeDatetime(_ctx.journey.arrivalDate)), 1),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("result.to")), 1),
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.titleCaseGare(_ctx.journey.destination.label)), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createTextVNode(_toDisplayString(_ctx.journey.trainEquipment) + " n°", 1),
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.journey.trainNumber), 1)
          ])
        ]),
        (_ctx.moreInfo)
          ? (_openBlock(), _createElementBlock("blockquote", _hoisted_17, [
              _createTextVNode(_toDisplayString(_ctx.$t("result.moreInfo.prefix")) + " ", 1),
              _createElementVNode("mark", null, _toDisplayString(_ctx.$t("result.moreInfo.highlight")), 1),
              _createTextVNode(_toDisplayString(_ctx.$t("result.moreInfo.suffix")), 1),
              _hoisted_18,
              _hoisted_19,
              _createElementVNode("small", null, [
                _createTextVNode(_toDisplayString(_ctx.$t("result.moreInfo.smallPrefix")) + " ", 1),
                _createElementVNode("a", _hoisted_20, _toDisplayString(_ctx.$t("result.moreInfo.smallLink")), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("result.moreInfo.smallSuffix")), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}